




























import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component } from 'vue-property-decorator';
import MswAppFooter from '../../msw-app-footer/msw-app-footer.vue';
import MswLinks from '../../shared/msw-links.vue';
import SwLogin from './components/sw-login.vue';
import { LoginModel } from './interfaces/sw-login-interfaces';
import MswStatusInfo from '@/core/msw-app-content/components/status-info.vue';
@Component({
  components: {
    SwLogin,
    MswAppFooter,
    MswLinks,
    MswStatusInfo,
  },
})
export default class MswDpLogin extends SwExtendedVue {

  loginModel: LoginModel = {
    loginAttempted: false,
    email: '',
    password: '',
  };
  doLogin() {
    this.$router.push({ path: '/m/feature/dashboard' });
  }
}
